import { TAO_KOE } from '../libs';

const compareStrings = ( valueA, valueB ) => {
	const lang = document.documentElement.lang || navigator.language;

	const stringA = '' + valueA;
	const stringB = '' + valueB;

	return stringA.toString().localeCompare( stringB.toString(), lang, { sensitivity: 'accent' } );
};

const recursiveThemeReducer = ( result, theme ) => {
	if ( theme.selected ) {
		result = result.concat( theme );
	}

	if ( theme.children && theme.children.length ) {
		result = result.concat( theme.children.reduce( recursiveThemeReducer, [] ) );
	}

	return result;
};

class ShopDataHandler {
	constructor( filterJSON = window.filterJSON ) {
		this.filterJSON = filterJSON;
	}

	ActiveReducers = {
		'themes': recursiveThemeReducer,
	};

	getFilterGroup( identifier ) {
		if ( 'undefined' === typeof this.filterJSON ) {
			return false;
		}

		if ( 'category' === identifier ) {
			return this.getCategoriesTree();
		}

		return this.filterJSON.find( ( filter ) => identifier === filter.identifier );
	}

	getFilter( filterGroupName, identifier ) {
		// Skip when no identifier.
		if ( ! identifier ) {
			return true;
		}

		// Skip when no FilterGroup.
		const filterGroup = this.getFilterGroup( filterGroupName );
		if ( ! filterGroup ) {
			return true;
		}

		if ( 'category' === filterGroupName ) {
			// Find Category.
			return this.getCategoriesFlat().find( ( filter ) => filter.identifier === identifier );
		} else if ( 'salenew' === filterGroupName ) {
			// Compare value.
			return filterGroup.filter.find( ( filter ) => filter.name === identifier && filter.value.toString() === '1' );
		}

		// Compare value.
		return filterGroup.filter.find( ( filter ) => 0 === compareStrings( filter.value, identifier ) );
	}

	getActiveFilters( filterGroupName ) {
		// Skip when no identifier.
		if ( ! filterGroupName ) {
			return false;
		}

		// Skip when no FilterGroup.
		const filterGroup = this.getFilterGroup( filterGroupName );
		if ( ! filterGroup ) {
			return false;
		}

		// In case the filters are not an array.
		const filters = Object.values( filterGroup.filter );

		// Handle Special Cases, like Jungen/Mädchen in Theme Filter.
		if ( 'function' === typeof this.ActiveReducers[ filterGroupName ] ) {
			return filters.reduce( this.ActiveReducers[ filterGroupName ], [] );
		}

		return filters.filter( ( filter ) => filter.selected );
	}

	hasActiveFilters( filterGroupName ) {
		const activeFilters = this.getActiveFilters( filterGroupName ) || [];
		return activeFilters.length > 0;
	}

	getCategoriesTree() {
		return this.getFilterGroup( 'tree' );
	}

	getCategoriesFlat() {
		const tree = this.getCategoriesTree() || false;
		if ( ! tree ) {
			return [];
		}

		return ( function recursiveCategoryTreeReducer( children ) {
			const current = Object.values( children || [] );
			return current.reduce( ( prev, child ) => {
				let next = prev.concat( child );

				if ( child.children && child.children.length > 0 ) {
					next = next.concat( recursiveCategoryTreeReducer( child.children ) );
				}

				return next;
			}, [] );
		} )( tree.filter[ 0 ].categories );
	}
}

const Shop = new ShopDataHandler();
Shop.buildShopUrl = function( parts = [] ) {
	if ( ! Array.isArray( parts ) ) {
		parts = parts.split( '/' );
	}

	// Filter empty parts.
	parts = parts.filter( ( p ) => p && p !== 'null' );

	const testPart = ( part ) => part.match( /(shop-(.*)|(.*)\-markenshop)/ );
	const hasBase = parts.find( testPart );
	if ( ! hasBase ) {
		const currentBase = document.location.pathname.split( '/' ).find( testPart ) || 'shop';
		parts = [ currentBase ].concat( parts );
	}

	// Trim leading and trailingslashes before join.
	parts = parts.map( ( part ) => part.trim( '/' ) );

	// Join
	return '/' + parts.join( '/' ) + '/';
};

// Expose.
TAO_KOE.Shop = Shop;

export {
	Shop as default,
	ShopDataHandler,
};
